import type { ProjectDef } from '../features/cabinet/types';

/** Направления кабинета оператора чата. */
export const PROJECTS_LIST: ProjectDef[] = [
  {
    id: 'proj_1',
    icon: 'ri-shopping-cart-line',
    color: '#5348e8',
    title: 'E-commerce',
    description: 'Поддержка клиентов онлайн-магазинов (вопросы по заказам, доставке, возвратам, ассортименту).',
  },
  {
    id: 'proj_2',
    icon: 'ri-code-s-slash-line',
    color: '#f0cbaa',
    title: 'IT и SaaS',
    description: 'Помощь пользователям программных продуктов или облачных сервисов (технические вопросы, настройка, функционал).',
  },
  {
    id: 'proj_3',
    icon: 'ri-bank-line',
    color: '#8b5cf6',
    title: 'Финансовый сектор',
    description: 'Консультации по банковским продуктам, кредитам, инвестициям (после глубокого обучения и с соблюдением всех регуляций).',
  },
  {
    id: 'proj_4',
    icon: 'ri-customer-service-line',
    color: '#ef4444',
    title: 'Сфера услуг',
    description: 'Поддержка клиентов сервисов доставки, бронирования, образовательных платформ и т.д.',
  },
  {
    id: 'proj_5',
    icon: 'ri-wifi-line',
    color: '#06b6d4',
    title: 'Телекоммуникации',
    description: 'Консультации по тарифам, услугам связи, настройке оборудования.',
  },
];

/**
 * Те же направления для кабинета менеджера социальных сетей: категории и id совпадают
 * с операторскими (id значимы — по ним хранится выбор в localStorage), описания
 * переписаны под работу с комментариями и сообщениями в соцсетях.
 */
export const SMM_PROJECTS_LIST: ProjectDef[] = [
  {
    id: 'proj_1',
    icon: 'ri-shopping-cart-line',
    color: '#5348e8',
    title: 'E-commerce',
    description: 'Соцсети онлайн-магазинов: комментарии и личные сообщения по заказам, доставке, возвратам, ассортименту.',
  },
  {
    id: 'proj_2',
    icon: 'ri-code-s-slash-line',
    color: '#f0cbaa',
    title: 'IT и SaaS',
    description: 'Соцсети программных продуктов и облачных сервисов: вопросы по функционалу и настройке, работа с отзывами пользователей.',
  },
  {
    id: 'proj_3',
    icon: 'ri-bank-line',
    color: '#8b5cf6',
    title: 'Финансовый сектор',
    description: 'Соцсети банков и финансовых сервисов: комментарии по продуктам, кредитам, инвестициям (после глубокого обучения и с соблюдением всех регуляций).',
  },
  {
    id: 'proj_4',
    icon: 'ri-customer-service-line',
    color: '#ef4444',
    title: 'Сфера услуг',
    description: 'Соцсети сервисов доставки, бронирования, образовательных платформ: сообщения, комментарии, отработка отзывов.',
  },
  {
    id: 'proj_5',
    icon: 'ri-wifi-line',
    color: '#06b6d4',
    title: 'Телекоммуникации',
    description: 'Соцсети операторов связи: вопросы по тарифам и услугам, настройке оборудования, работа с обращениями в комментариях.',
  },
];

/**
 * Направления кабинета онлайн-менеджера (зеркало om, тема industrial). Тексты и id —
 * операторские (id значимы — по ним хранится выбор); цвета иконок — из палитры темы,
 * иначе индиго и фиолетовый выбиваются из жёлто-чёрного.
 */
const INDUSTRIAL_PROJECT_COLORS = ['#ffc20e', '#f7f1e3', '#f5a000', '#f27405', '#ffd75e'];

export const ONLINE_PROJECTS_LIST: ProjectDef[] = PROJECTS_LIST.map((p, i) => ({
  ...p,
  color: INDUSTRIAL_PROJECT_COLORS[i % INDUSTRIAL_PROJECT_COLORS.length],
}));
